import { render, staticRenderFns } from "./tooltip.vue?vue&type=template&id=313c9d22&scoped=true"
import script from "./tooltip.vue?vue&type=script&lang=ts"
export * from "./tooltip.vue?vue&type=script&lang=ts"
import style0 from "./tooltip.vue?vue&type=style&index=0&id=313c9d22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313c9d22",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
